module.exports = __webpack_public_path__ + "static/img/img3.6dc044e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scenariusze/img/img3.png
// module id = 4w/r
// module chunks = 0